import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, fill: "none", viewBox: "0 0 12 12", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#98A9BC", d: "m0 3.376.736-.736L6 7.905l5.264-5.265.736.736L6.368 9.01 6 9.36l-.368-.352z" }));
const ForwardRef = forwardRef(SvgChevronDown);
export { ForwardRef as ReactComponent };
